import { darken } from 'polished';
import { styled } from 'styled-components';

export const Container = styled.div`
  width: 100%;
`;

export const Content = styled.div`
  padding: 2.5rem 0;
`;

export const PreviewInformation = styled.div`
  background: ${({ theme }) => theme.colors.white};
  padding-bottom: 2.5rem;

  .wrapper {
    max-width: 39.5rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-bottom: 1.5rem;

    .chakra-avatar__group {
      width: 180px;
      margin-top: -30px;

      .chakra-avatar {
        width: 50%;
        height: 90px;
        background-color: ${({ theme }) => darken(0.1, theme.colors.light.color)};
        border: 4px solid ${({ theme }) => theme.colors.white};
        box-shadow: 0px 5px 15px 0px rgba(0, 0, 0, 0.05);
      }
    }
  }
`;

export const Title = styled.h2`
  font-size: 1.375rem;
  line-height: 1.563rem;
  text-align: center;
  color: ${({ theme }) => theme.colors.primary.color};
  margin: 1rem 0 2rem;
`;

export const ConfirmedContainer = styled.div`
  width: 100%;
  padding: 1rem;
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;
  margin-top: 0.7rem;

  button {
    width: 100%;
  }
`;
